export default __webpack_public_path__ + "static/media/delete.9f58db2e.svg";